export const handleClientFieldValueChange = (
  setClientDetails: React.Dispatch<React.SetStateAction<any>>,
  setRecipientOptions: React.Dispatch<React.SetStateAction<any[]>>,
  clientDetails: any,
  e: React.ChangeEvent<HTMLInputElement>,
  key: string
) => {
  setClientDetails((prevDetails: any) => ({
      ...prevDetails,
      [key]: e.target.value,
  }));

  setRecipientOptions((prevOptions) =>
      prevOptions.map((option) =>
          option.value === clientDetails[key]
              ? { ...option, label: e.target.value, value: e.target.value }
              : option
      )
  );
};


export const openClientDetailsNav = (setClientDetailsOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
  setClientDetailsOpen(true);
};

export const closeClientDetailsNav = (setClientDetailsOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
  setClientDetailsOpen(false);
};
